import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { Flex, Inline, xcss } from '@atlaskit/primitives';
import { N40 } from '@atlaskit/theme/colors';
import { asyncPopupSelectMessages } from './messages';
var footerContainerStyles = xcss({
  paddingTop: 'space.050',
  paddingBottom: 'space.050',
  borderTop: "".concat("var(--ds-border, ".concat(N40, ")"), " solid 1px")
});
var footerPaginationInfoStyles = xcss({
  color: 'color.text.subtlest',
  marginBlock: 'space.100',
  marginInline: 'space.150'
});
var PopupFooter = function PopupFooter(_ref) {
  var currentDisplayCount = _ref.currentDisplayCount,
    totalCount = _ref.totalCount,
    filterName = _ref.filterName;
  return /*#__PURE__*/React.createElement(Flex, {
    testId: "".concat(filterName, "--footer"),
    direction: "row",
    alignItems: "center",
    justifyContent: "end",
    xcss: footerContainerStyles
  }, /*#__PURE__*/React.createElement(Inline, {
    xcss: footerPaginationInfoStyles
  }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, asyncPopupSelectMessages.paginationDetails, {
    values: {
      currentDisplayCount: currentDisplayCount,
      totalCount: totalCount
    }
  }))));
};
export default PopupFooter;